import React from 'react'
import { Button } from 'react-bootstrap'
import { Plus } from 'lucide-react'

export default function PlusButton(props) {

    const { onClick } = props

    return (
        <>
            <Button
                type='button'
                variant='light'
                size='sm'
                className='icon_add_btn'
                onClick={onClick}
            >
                <Plus size={16} strokeWidth={2} />
            </Button>
        </>
    )
}
